// Constans
import { ROLES } from '@/constants'
// Components
import CardContainer from '@/components/ui/CardContainer'
import DataColumns from '@/components/ui/DataColumns'
import PlaceByTabs from '@/components/elements/app/PlaceByTabs'
import VuetifyContentLoading from '@/components/ui/VuetifyContentLoading'
import VuetifyToolBar from '@/components/ui/VuetifyToolBar'
// Mixins
import uiMixin from '@/mixins/uiMixin'
// Vuex
import { mapGetters } from 'vuex'
// Filters
import { formatNumber } from '@/filters'
// Services
import { getManagedPlacesByPartnerId } from '@/services/partner'
import { getManagedPlacesByBrandId } from '@/services/brand'
import { getManagedPlacesByReferredId } from '@/services/reffered'
// Utils
import { get, isNil } from 'lodash'

export default {
  name: 'Dashboard',
  components: {
    CardContainer,
    DataColumns,
    PlaceByTabs,
    VuetifyContentLoading,
    VuetifyToolBar
  },
  mixins: [uiMixin],
  data() {
    return {
      // data
      placeStatistics: [],
      // others
      processingRequest: true
    }
  },
  watch: {
    async companyData() {
      // Obtenemos todos los datos
      await this.setPlaceStatistics()
    }
  },
  computed: {
    ...mapGetters('company', ['companyData']),
    ...mapGetters('authentication', ['userData'])
  },
  async mounted() {
    await this.getEveryNeededData()
  },
  methods: {
    /**
     * Obtenemos todos los datos a mostrar en el componente
     */
    async getEveryNeededData() {
      // Obtenemos todos los datos
      await this.setPlaceStatistics()
    },
    /**
     * Obtenemos datos de total de establecimientos
     */
    async setPlaceStatistics() {
      try {
        // Loading
        this.processingRequest = true

        if (!isNil(this.companyData.id)) {
          // Usuario es "partner"
          const isPartner = ROLES.partner_partner.value === this.userData.role
          // establecimientos gestionados
          const managedPlaces = await getManagedPlacesByPartnerId(this.companyData.id)

          // establecimientos "referenciados"
          let referredPlaces = null
          if (isPartner) {
            referredPlaces = await getManagedPlacesByReferredId(this.companyData.id)
          }

          // establecimientos "brandeados"
          let brandedPlaces = null
          if (!isPartner) {
            brandedPlaces = await getManagedPlacesByBrandId(this.companyData.id)
          }

          const data = {
            totalManaged: managedPlaces.length,
            ...(!isNil(referredPlaces) ? { totalReferrals: referredPlaces.length } : {}),
            ...(!isNil(brandedPlaces) ? { totalBranded: brandedPlaces.length } : {})
          }

          // Establecimiento gestionados
          this.placeStatistics = [
            {
              label: 'Gestionados',
              value: formatNumber(get(data, 'totalManaged', 0))
            }
          ]

          // Establecimiento referidos
          if (!isNil(referredPlaces)) {
            this.placeStatistics.push({
              label: 'Referidos',
              value: formatNumber(get(data, 'totalReferrals', 0))
            })
          }

          // Establecimientos "brandeados"
          if (!isNil(brandedPlaces)) {
            this.placeStatistics.push({
              label: 'Patrocinados',
              value: formatNumber(get(data, 'totalBranded', 0))
            })
          }
        }
      } catch (error) {
        this.modifyAppAlert({
          type: 'error',
          text: error.message,
          visible: true
        })
      } finally {
        this.processingRequest = false
      }
    }
  }
}
